import { RemoveFromExcludedListDialogProps } from "./RemoveFromExcludedListDialog.tsx";
import { put } from "../../../../common/api/apiShared.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useRemoveFromExcludedListDialog(props: RemoveFromExcludedListDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const { translateString } = useTranslation();

    const removeFromExcludedListMutation = useDotLegalMutation(removeFromExcludedListApi);
    const onRemoveFromExcludedList = () => {
        removeFromExcludedListMutation.mutateAsync(undefined, {
            onSuccess: () => {
                snackbar.show(translateString("removedFromExcluded"));
                props.onRemoveFromExcludedList();
            },
        });
    };

    return {
        inProgress: removeFromExcludedListMutation.isLoading,
        onRemoveFromExcludedList,
    };

    function removeFromExcludedListApi() {
        return put(`/contract-user-access/${props.contractId}/remove-excluded/${props.userId}`, null);
    }
}
